import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import type { TableRow } from '../../template/Table';
import TableGrid from './TableGrid';
import TableMobileViewInlinePreview from './TableMobileViewInlinePreview';
import TableToolbar from './TableToolbar';
import { useTableEditor } from './useTableEditor';
import { useTableImport } from './useTableImport';
import { useTableMobileView } from './useTableMobileView';

interface TableEditorViewTabsProps {
  viewTab: 'desktop' | 'mobile';
  onViewTabChange: (value: 'desktop' | 'mobile') => void;
  editor: ReturnType<typeof useTableEditor>;
  importer: ReturnType<typeof useTableImport>;
  mobileView: ReturnType<typeof useTableMobileView>;
  rows: TableRow[];
}

/** Desktop/Mobile tab switcher for a non-empty table block — grid + toolbar on Desktop, mobile-view preview on Mobile. */
export default function TableEditorViewTabs({
  viewTab,
  onViewTabChange,
  editor,
  importer,
  mobileView,
  rows,
}: TableEditorViewTabsProps) {
  return (
    <>
      <Tabs
        value={viewTab}
        onChange={(_event, value: 'desktop' | 'mobile') => onViewTabChange(value)}
        sx={{ minHeight: 36, mb: 1 }}
      >
        <Tab label="Desktop" value="desktop" sx={{ minHeight: 36, py: 0.5 }} />
        <Tab label="Mobile" value="mobile" sx={{ minHeight: 36, py: 0.5 }} />
      </Tabs>

      {viewTab === 'desktop' ? (
        <>
          <TableToolbar editor={editor} onImportFile={importer.importFile} busy={importer.busy} />
          {importer.error && (
            <Box sx={{ color: 'error.main', fontSize: '0.8rem' }}>{importer.error}</Box>
          )}
          <TableGrid editor={editor} onImportImage={importer.importImage} />
        </>
      ) : (
        <>
          {mobileView.error && (
            <Box sx={{ color: 'error.main', fontSize: '0.8rem' }}>{mobileView.error}</Box>
          )}
          <TableMobileViewInlinePreview mobileView={mobileView} rows={rows} />
        </>
      )}
    </>
  );
}
